<!--
  - SPDX-FileCopyrightText: 2018 Nextcloud contributors
  - SPDX-License-Identifier: AGPL-3.0-or-later
-->

<script setup lang="ts">
import { computed, onMounted, onUnmounted } from 'vue'
import { t } from '@nextcloud/l10n'

import NcEmptyContent from '@nextcloud/vue/components/NcEmptyContent'

import ActivityIcon from 'vue-material-design-icons/LightningBoltOutline.vue'

import Activities from '../Activity/Activities.vue'
import { useActivityStore } from '../../stores/activity'
import { onBeforeRouteUpdate } from 'vue-router'

const activityStore = useActivityStore()
const emptyContentProps = {
	name: t('polls', 'No activity yet'),
}

const showEmptyContent = computed(
	() => activityStore.getActivitiesForPoll.length === 0,
)

onMounted(() => {
	activityStore.load()
})

onBeforeRouteUpdate(async () => {
	activityStore.load()
})

onUnmounted(() => {
	activityStore.$reset()
})
</script>

<template>
	<Activities v-if="!showEmptyContent" />
	<NcEmptyContent v-else v-bind="emptyContentProps">
		<template #icon>
			<ActivityIcon />
		</template>
	</NcEmptyContent>
</template>
